import { slugs } from 'common/constants/inputTypes'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import ColumnOld from 'publisher/components/ColumnOld'
import AgreementOld from 'publisher/components/entities/Agreement'
import AudioNew from 'publisher/components/entities/AudioNew'
import BlogContentPlaceholderNew from 'publisher/components/entities/BlogContentPlaceholderNew'
import BlogPostContentPlaceholderNew from 'publisher/components/entities/BlogPostContentPlaceholderNew'
import BlogPageBody from 'publisher/components/entities/blog-page-body'
import { BlogPostBody } from 'publisher/components/entities/blog-post-body'
import { BlogPostLayoutBody } from 'publisher/components/entities/blog-post-layout-body'
import { Body } from 'publisher/components/entities/body'
import BookingCalendar from 'publisher/components/entities/booking-calendar/index'
import { PreviewBookingCalendar } from 'publisher/components/entities/booking-calendar/preview-booking-calendar'
import { RescheduleBookingCalendar } from 'publisher/components/entities/booking-calendar/reschedule-booking-calendar'
import ContentTable from 'publisher/components/entities/ContentTable'
import Countdown from 'publisher/components/entities/Countdown'
import BaseField from 'publisher/components/entities/Field/BaseField'
import CompanyNameField from 'publisher/components/entities/Field/CompanyNameField'
import CountryField from 'publisher/components/entities/Field/CountryField'
import EmailField from 'publisher/components/entities/Field/EmailField'
import PhoneNumberField from 'publisher/components/entities/Field/PhoneNumberField'
import BaseFieldNew from 'publisher/components/entities/field-new/base-field'
import CompanyNameFieldNew from 'publisher/components/entities/field-new/company-name-field'
import CountryFieldNew from 'publisher/components/entities/field-new/country-field'
import EmailFieldNew from 'publisher/components/entities/field-new/email-field'
import PhoneNumberFieldNew from 'publisher/components/entities/field-new/phone-number-field'
import Image from 'publisher/components/entities/Image'
import InlineBody from 'publisher/components/entities/inline-body'
import NewBulletList from 'publisher/components/entities/NewBulletList'
import NewCustomLogin from 'publisher/components/entities/NewCustomLogin'
import NewHorizontalLine from 'publisher/components/entities/NewHorizontalLine'
import OfferThankYouOrderSummaryNew from 'publisher/components/entities/OfferThankYouOrderSummaryNew'
import OptInButton from 'publisher/components/entities/OptInButton'
import PaymentButton from 'publisher/components/entities/PaymentButton'
import PaymentButtonNew from 'publisher/components/entities/PaymentButtonNew'
import { PopupNew } from 'publisher/components/entities/popup-new'
import RemotePopupBody from 'publisher/components/entities/remote-popup-body'
import Section from 'publisher/components/entities/Section'
import SectionOld from 'publisher/components/entities/Section/SectionOld'
import ShippingFees from 'publisher/components/entities/ShippingFees'
import StartTimer from 'publisher/components/entities/StartTimer'
import SurveyNew from 'publisher/components/entities/Survey/SurveyNew'
import TextNew from 'publisher/components/entities/TextNew'
import TwitterTweetButton from 'publisher/components/entities/TwitterTweetButton'
import { TwoStepPaymentForm as TwoStepPaymentFormNew } from 'publisher/components/entities/two-step-payment-form'
import VideoNew from 'publisher/components/entities/Video'
import RowOld from 'publisher/components/RowOld'
import BlogPostCategoriesNew from 'publisher/pages/blog-layout/components/BlogPostCategoriesNew'
import BlogPostDateNew from 'publisher/pages/blog-layout/components/BlogPostDateNew'
import BlogPostListingNew from 'publisher/pages/blog-page/components/BlogPostListingNew'
import LatestBlogPostsCarousel from 'publisher/pages/blog-page/components/LatestBlogPostsCarousel'
import LatestBlogPostsNew from 'publisher/pages/blog-page/components/LatestBlogPostsNew'
import TaxNumber from 'publisher/pages/offer-page/components/TaxNumber'
import TaxNumberNew from 'publisher/pages/offer-page/components/tax-number'
import PriceElement from 'publisher/pages/sale-page/components/price-element'
import React from 'react'
import { Agreement } from 'src/publisher/entities/agreement'
import OptInButtonNew from 'src/publisher/entities/button-new'
import Checkbox from 'src/publisher/entities/checkbox/checkbox'
import { Coupon } from 'src/publisher/entities/coupon'
import { Form } from 'src/publisher/entities/form'
import { Menu } from 'src/publisher/entities/menu'
import ContactUsButton from 'src/publisher/pages/contact-us/entities/contact-us-button'
import SalesRedirectionButtonNew from 'src/publisher/pages/sales/entities/sales-redirection-button'
import WebinarSessionCallToActionNew from 'src/publisher/pages/webinar-session/entities/webinar-call-to-action-new'
import BlogCategoryDescription from '../../components/entities/BlogCategoryDescription'
import BlogCategoryTitle from '../../components/entities/BlogCategoryTitle'
import BlogPostImage from '../../components/entities/BlogPostImage'
import Breadcrumbs from '../../components/entities/Breadcrumbs'
import { BookingPaidCalendar } from '../../components/entities/booking-calendar/booking-paid-calendar/booking-paid-calendar'
import Carousel from '../../components/entities/Carousel'
import Column from '../../components/entities/Column'
import ContentBox from '../../components/entities/ContentBox'
import CustomLoginForgotPassword from '../../components/entities/CustomLoginForgotPassword'
import Faq from '../../components/entities/Faq'
import PasswordField from '../../components/entities/Field/PasswordField'
import Headline from '../../components/entities/Headline'
import NewLanguageSwitcher from '../../components/entities/NewLanguageSwitcher'
import NewRawHtml from '../../components/entities/NewRawHtml'
import OptInRecaptcha from '../../components/entities/OptInRecaptcha'
import Row from '../../components/entities/Row'
import BlogPostTitleNew from '../../pages/blog-layout/components/BlogPostTitleNew'
import Attachments from '../../pages/contact-us/components/Attachments'
import ContactUs from '../../pages/contact-us/components/ContactUs'
import ContactUsField from '../../pages/contact-us/components/ContactUsField'
import Recaptcha from '../../pages/contact-us/components/Recaptcha'
import TextArea from '../../pages/contact-us/components/TextArea'
import CustomerTypeNew from '../../pages/offer-page/components/CustomerType'
import OfferPrice from '../../pages/offer-page/components/OfferPrice'
import OrderBump from '../../pages/offer-page/components/order-bump'
import PaymentMethodNew from '../../pages/offer-page/components/PaymentMethod'
import Product from '../../pages/offer-page/components/Product'
import DownsellPaymentButton from '../../pages/UpsellPage/components/DownsellPaymentButton'
import UpsellPaymentButtonNew from '../../pages/UpsellPage/components/UpsellPaymentButton'
import WebinarRegistrationDate from '../../pages/webinar-registration/components/WebinarRegistrationDate'
import WebinarSessionVideoNew from '../../pages/webinar-session/components/WebinarSessionVideoNew'
import WebinarSessionLinkNew from '../../pages/webinar-thank-you/components/WebinarSessionLinkNew'

export default function createEntityElement() {
  return (entity, additionalProps) => {
    const key = `entity-${entity.id}`
    switch (entity.type) {
      case EntityTypeEnum.Body:
        return <Body entity={entity} key={key} />
      case EntityTypeEnum.BlogPageBody:
        return <BlogPageBody entity={entity} key={key} />
      case EntityTypeEnum.BlogPostLayoutBody:
        return <BlogPostLayoutBody entity={entity} key={key} />
      case structureTypes.SECTION:
        return <SectionOld entity={entity} key={key} />
      case structureTypes.ROW:
        return <RowOld entity={entity} key={key} />
      case structureTypes.COLUMN:
        return <ColumnOld entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.Section:
        return <Section entity={entity} key={key} />
      case EntityTypeEnum.Row:
        return <Row entity={entity} key={key} />
      case EntityTypeEnum.Column:
        return <Column entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.BulletList:
        return <NewBulletList entity={entity} key={key} />
      case EntityTypeEnum.BookingPaidCalendar:
        return <BookingPaidCalendar entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendar:
        return <BookingCalendar entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendarPreview:
        return <PreviewBookingCalendar entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendarReschedule:
        return <RescheduleBookingCalendar entity={entity} key={key} />
      case structureTypes.BUTTON:
        return <OptInButton entity={entity} key={key} />
      case structureTypes.FORM_INPUT:
        switch (entity.options.slug) {
          case slugs.EMAIL:
            return <EmailField entity={entity} />
          case slugs.COUNTRY:
            return <CountryField entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberField entity={entity} />
          case slugs.TAX_NUMBER:
            return <TaxNumber entity={entity} />
          case slugs.COMPANY_NAME:
            return <CompanyNameField entity={entity} />
          case slugs.PASSWORD:
          case slugs.CONFIRM_PASSWORD:
            return <PasswordField entity={entity} />
          default:
            return <BaseField entity={entity} />
        }
      case EntityTypeEnum.Field:
        switch (entity.slug) {
          case slugs.EMAIL:
            return <EmailFieldNew entity={entity} />
          case slugs.COUNTRY:
            return <CountryFieldNew entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberFieldNew entity={entity} />
          case slugs.TAX_NUMBER:
            return <TaxNumberNew entity={entity} />
          case slugs.COMPANY_NAME:
            return <CompanyNameFieldNew entity={entity} />
          case slugs.PASSWORD:
          case slugs.CONFIRM_PASSWORD:
            return <BaseFieldNew entity={entity} type="password" />
          default:
            return <BaseFieldNew entity={entity} key={key} />
        }
      case EntityTypeEnum.Form:
        return <Form entity={entity} key={key} />
      case EntityTypeEnum.Button:
        return <OptInButtonNew entity={entity} key={key} />
      case EntityTypeEnum.RemotePopupBody:
        return (
          <RemotePopupBody entity={entity} key={key} {...additionalProps} />
        )
      case EntityTypeEnum.InlineBody:
        return <InlineBody entity={entity} key={key} />
      case EntityTypeEnum.ContentBox:
        return <ContentBox entity={entity} key={key} />
      case EntityTypeEnum.WebinarSessionLink:
        return <WebinarSessionLinkNew entity={entity} key={key} />
      case EntityTypeEnum.WebinarCallToAction:
        return <WebinarSessionCallToActionNew entity={entity} key={key} />
      case EntityTypeEnum.PaymentMethod:
        return <PaymentMethodNew entity={entity} key={key} />
      case EntityTypeEnum.OfferPrice:
        return <OfferPrice entity={entity} key={key} />
      case EntityTypeEnum.UpsellAgreeButton:
        return <UpsellPaymentButtonNew entity={entity} key={key} />
      case EntityTypeEnum.UpsellDisagreeButton:
        return <DownsellPaymentButton entity={entity} key={key} />
      case structureTypes.PAYMENT_BUTTON:
        return <PaymentButton entity={entity} key={key} />
      case EntityTypeEnum.PaymentButton:
        return <PaymentButtonNew entity={entity} key={key} />
      case EntityTypeEnum.Checkbox:
        return <Checkbox entity={entity} key={key} />
      case structureTypes.START_TIMER:
        return <StartTimer entity={entity} key={key} />
      case structureTypes.AGREEMENT:
        return <AgreementOld entity={entity} key={key} />
      case EntityTypeEnum.OrderSummary:
        return <OfferThankYouOrderSummaryNew entity={entity} key={key} />
      case EntityTypeEnum.Countdown:
        return <Countdown entity={entity} key={key} />
      case EntityTypeEnum.CustomLogin:
        return <NewCustomLogin entity={entity} key={key} />
      case EntityTypeEnum.CustomLoginForgotPassword:
        return <CustomLoginForgotPassword entity={entity} key={key} />
      case structureTypes.PHYSICAL_PRODUCT:
        return <div />
      case EntityTypeEnum.Product:
        return <Product entity={entity} key={key} />
      case EntityTypeEnum.SalesRedirectionButton:
        return <SalesRedirectionButtonNew entity={entity} key={key} />
      case EntityTypeEnum.Coupon:
        return <Coupon entity={entity} key={key} />
      case EntityTypeEnum.BlogPostBody:
        return <BlogPostBody entity={entity} key={key} />
      case EntityTypeEnum.BlogPostContentPlaceholder:
        return <BlogPostContentPlaceholderNew entity={entity} key={key} />
      case EntityTypeEnum.BlogContentPlaceholder:
        return <BlogContentPlaceholderNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostTitle:
        return <BlogPostTitleNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostCategories:
        return <BlogPostCategoriesNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostListing:
        return <BlogPostListingNew entity={entity} key={key} />
      case EntityTypeEnum.LatestBlogPosts:
        return <LatestBlogPostsNew entity={entity} key={key} />
      case EntityTypeEnum.BlogPostDate:
        return <BlogPostDateNew entity={entity} key={key} />
      case EntityTypeEnum.Menu:
        return <Menu entity={entity} key={key} />
      case EntityTypeEnum.LanguageSwitcher:
        return <NewLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.TwoStepPaymentForm:
        return <TwoStepPaymentFormNew entity={entity} key={key} />
      case EntityTypeEnum.HorizontalLine:
        return <NewHorizontalLine entity={entity} key={key} />
      case EntityTypeEnum.TwitterTweetButton:
        return <TwitterTweetButton entity={entity} key={key} />
      case EntityTypeEnum.Survey:
        return <SurveyNew entity={entity} key={key} />
      case EntityTypeEnum.Carousel:
        return <Carousel entity={entity} key={key} />
      case EntityTypeEnum.Faq:
        return <Faq entity={entity} key={key} />
      case EntityTypeEnum.PriceElement:
        return <PriceElement entity={entity} key={key} />
      case EntityTypeEnum.WebinarRegistrationDate:
        return <WebinarRegistrationDate entity={entity} key={key} />
      case EntityTypeEnum.Text:
        return <TextNew entity={entity} key={key} />
      case EntityTypeEnum.Headline:
        return <Headline entity={entity} key={key} />
      case EntityTypeEnum.BlogPostImage:
        return <BlogPostImage entity={entity} key={key} />
      case EntityTypeEnum.ContentTable:
        return <ContentTable entity={entity} key={key} />
      case EntityTypeEnum.ContactUs:
        return <ContactUs entity={entity} key={key} />
      case EntityTypeEnum.ContactUsField:
        return <ContactUsField entity={entity} key={key} />
      case EntityTypeEnum.ContactUsButton:
        return <ContactUsButton entity={entity} key={key} />
      case EntityTypeEnum.Recaptcha:
      case EntityTypeEnum.ContactUsRecaptcha:
        return <Recaptcha entity={entity} key={key} />
      case EntityTypeEnum.OptInRecaptcha:
        return <OptInRecaptcha entity={entity} key={key} />
      case EntityTypeEnum.TextArea:
        return <TextArea entity={entity} key={key} />
      case EntityTypeEnum.Breadcrumbs:
        return <Breadcrumbs entity={entity} key={key} />
      case EntityTypeEnum.Attachments:
        return <Attachments entity={entity} key={key} />
      case EntityTypeEnum.Video:
        return <VideoNew entity={entity} key={key} />
      case EntityTypeEnum.Image:
        return <Image entity={entity} key={key} />
      case EntityTypeEnum.LatestBlogPostsCarousel:
        return <LatestBlogPostsCarousel entity={entity} key={key} />
      case EntityTypeEnum.Audio:
        return <AudioNew entity={entity} key={key} />
      case EntityTypeEnum.CustomerType:
        return <CustomerTypeNew entity={entity} key={key} />
      case EntityTypeEnum.WebinarSessionVideo:
        return <WebinarSessionVideoNew entity={entity} key={key} />
      case EntityTypeEnum.Comments:
        return <div /> // just to not fail blocks creation, will be removed
      case EntityTypeEnum.BlogCategoryTitle:
        return <BlogCategoryTitle entity={entity} key={key} />
      case EntityTypeEnum.BlogCategoryDescription:
        return <BlogCategoryDescription entity={entity} key={key} />
      case EntityTypeEnum.RawHtml:
        return <NewRawHtml entity={entity} key={key} />
      case EntityTypeEnum.ShippingFees:
        return <ShippingFees entity={entity} key={key} />
      case EntityTypeEnum.Agreement:
        return <Agreement entity={entity} key={key} />
      case EntityTypeEnum.OrderBump:
        return <OrderBump entity={entity} key={key} />
      case EntityTypeEnum.Popup:
        return <PopupNew entity={entity} key={key} {...additionalProps} />
      default:
        // just a temp solution
        return <div />
      // throw new Error(`unknown type ${entity.type} of node id = ${entity.id}`)
    }
  }
}
